import { Flame } from "lucide-react";
import { readingStreak } from "@/lib/reader";

export default function StreakBadge({ days }) {
  const { current, best, readToday } = readingStreak(days);
  if (!days?.length) return null;
  const hint = current === 0
    ? "Read or listen today to start a new streak."
    : readToday
      ? "You've read today — come back tomorrow to keep it going."
      : "Read or listen today to keep your streak alive!";
  return (
    <div className="flex items-center gap-4" data-testid="library-streak">
      <span className={`w-12 h-12 flex items-center justify-center border ${current ? "border-[#e0982f]/60 bg-[#e0982f]/10" : "border-white/15"}`}>
        <Flame className={`w-6 h-6 ${current ? "text-[#e0982f] floaty" : "text-soft"}`} />
      </span>
      <p>
        <span className="block font-mono-ui text-[10px] uppercase tracking-[0.22em] text-soft">Reading streak</span>
        <span className="font-serif-display text-3xl" data-testid="library-streak-current">{current} day{current === 1 ? "" : "s"}</span>
        <span className="block text-soft text-xs mt-1" data-testid="library-streak-hint">{hint}{best > current ? ` Best: ${best} day${best === 1 ? "" : "s"}.` : ""}</span>
      </p>
    </div>
  );
}
